import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=78b2d72c&scoped=true"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"
import style0 from "./Drag.vue?vue&type=style&index=0&id=78b2d72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2d72c",
  null
  
)

export default component.exports